import { styled } from '@abyss/web/tools/styled';
import { Alert } from '@abyss/web/ui/Alert';
import { Flex } from '@abyss/web/ui/Flex';

export const StyledPCPWrapper = styled('div', {
  borderBottom: '1px solid $cardBorder',
  marginBottom: '$sm',

  '@screen < $sm': {
    borderTop: '1px solid $cardBorder',
  },
});

export const StyledPCPAlert = styled(Alert, {
  '&.abyss-alert-title': {
    color: '$gray8 !important',
  },
});

export const collapseContainer = (mobileScreen: boolean) => ({
  alignItems: 'start',
  borderWidth: '1px 0px',
  borderStyle: 'solid',
  borderColor: '$cardBorder',
  marginTop: '$sm',
  padding: '$lg calc((100% - 1200px) / 2)',

  '@media (max-width: 1248px)': {
    padding: '$lg',
  },
  ...(mobileScreen && {
    padding: '0px !important',
    border: '0px',
    marginBottom: '0px',
    marginTop: '0',
  }),
  '@screen < $sm': { padding: '0px' },
});

export const collapseContainerOtherProviders = (mobileScreen: boolean) => ({
  alignItems: 'start',
  borderWidth: '1px 0px',
  borderStyle: 'solid',
  borderColor: '$cardBorder',
  marginTop: '8px',
  padding: '$lg calc((100% - 1200px) / 2)',

  '@media (max-width: 1248px)': {
    padding: '$lg',
  },
  ...(mobileScreen && {
    padding: '0px !important',
    border: '0px',
    marginTop: '0',
  }),
  '@screen < $sm': { padding: '0px' },
});

export const collapseSection = (
  isFullWidth: boolean,
  tabletScreen: boolean,
  mobileScreen: boolean,
  widgetPhoneScreen?: boolean,
  WidgetDesktopScreen?: boolean,
  WidgetPages?: boolean
) => ({
  marginTop: '8px',
  ...(isFullWidth && {
    width: '100%',
    '.abyss-layout-group': {
      display: 'inline-block',
    },
  }),
  ...(!isFullWidth && {
    width: '50%',
    '@media (max-width: 743px)': {
      width: '100%',
    },
  }),
  ...(tabletScreen && {
    display: 'block !important',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '$md',
    gap: '4px',
    width: '100%',
    height: 'auto',
    background: '$white',
    borderWidth: '1px 0px',
    borderStyle: 'solid',
    borderColor: '#E5E5E6',
    borderRadius: '0px',
    flex: 'none',
    order: '4',
    flexGrow: '0',
  }),
  ...(WidgetPages && {
    display: 'block !important',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '4px',
    width: '100%',
    height: 'auto',
    background: '$white',
    borderWidth: '1px 0px',
    borderStyle: 'solid',
    borderColor: '#E5E5E6',
    borderRadius: '0px',
    flex: 'none',
    order: '4',
    flexGrow: '0',
    margin: ' 8px 0 0 0',
    '.abyss-psx-parcel-c-enKwaM-igvblZO-css': {
      margin: '0px',
    },
  }),
  ...(widgetPhoneScreen && {
    padding: ' 0 $md',
  }),
  ...(WidgetDesktopScreen && {
    padding: '0 $lg',
  }),
  ...(mobileScreen && {
    padding: '0 0 4px $md',
  }),
});

export const CollapseSubSection = styled(Flex, {
  gap: '12px',
  flexDirection: 'column',
  '.abyss-text-root': {
    lineHeight: '24px',
    '@screen < $sm': {
      lineHeight: '20px',
    },
  },
});

export const OtherDetailsContentTitle = styled('div', {
  dynamic: ({ cssProps: { isGEHAV2 } }) => ({
    color: isGEHAV2 ? '$primary1' : '#323334',
  }),
  fontWeight: '600',
  fontSize: '$md',
  lineHeight: '24px',
  '@screen < $sm': {
    lineHeight: '20px',
  },
});

export const CollapseCardHeaderStyle = (
  isWidget?: boolean,
  contentHeader?: string
) => ({
  backgroundColor: 'white',
  borderRadius: 'unset',
  border: 'none',
  borderLeft: 'none',
  borderRight: 'none',
  boxShadow: 'none',
  marginBottom: '16px',
  minHeight: 'unset',
  padding: '0',
  '.abyss-card-title': {
    margin: '$md 0',
    maxHeight: '24px',
  },
  '.abyss-accordion-header': {
    fontSize: '20.25px !important',
    fontWeight: 'bold !important',
    lineHeight: '24px !important',
    paddingRight:
      contentHeader === 'Cultural competency training' ? '0px' : '16px',
  },

  '.abyss-accordion-trigger': {
    gap: '16px',
    borderBottom: 'none',
    backgroundColor: 'white !important',
    padding: '8px 8px 15px 0px',
  },
  '.abyss-accordion-content-text': {
    padding: '0',
  },
  '.abyss-accordion-content-container': {
    color: '#4B4D4F',
    padding: '0',
    borderTop: 'none !important',
    lineHeight: '20px',
    fontSize: '16px !important',
  },
  ...(isWidget && {
    'abyss-accordion-content-container': {
      margin: '6px 0px 6px 4px',
      color: '#4B4D4F',
      padding: '0',
      borderTop: 'none !important',
      lineHeight: '20px',
    },
  }),
});

export const CollapseHospitalAffiliationsStyle = {
  color: '$interactive1',
  padding: '0',
  borderTop: 'none !important',
  fontWeight: '$bold',
};

export const HospitalAffiliationsContainerStyle = {
  'abyss-flex-root': {
    alignItems: 'center',
    gap: '4px',
    background: '$primary2',
    border: '0.5px solid #DADADA',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.12)',
    borderRadius: '8px',
    marginBottom: '$xs',
    marginRight: '$md',
    marginTop: '$xs',
    '@screen >= $md': {
      paddingRight: '16px',
      paddingLeft: '24px',
      height: '42px',
    },
    '@screen < $md': {
      paddingRight: '14px',
      paddingLeft: '4px',
      height: '40px',
    },
  },
};

export const collapseSectionNewDesign = {
  width: '100%',
  display: 'inline-block',
  '& .abyss-layout-stack': {
    width: '100%',
    display: 'inline-block',
  },
};
